import idx from 'idx';
import PropTypes from 'prop-types';
import { useQuery } from 'react-apollo';

import { isUnauthorizedError } from '@confluence/error-boundary';
import { markErrorAsHandled } from '@confluence/graphql';

import type { AdminKeyEligibility as AdminKeyEligibilityT } from './__types__/AdminKeyEligibilityQuery';
import { AdminKeyEligibilityQuery as AdminKeyEligibility } from './AdminKeyEligibilityQuery.graphql';

export function AdminKeyEligibilityQuery({ children }) {
	const { data, error, loading } = useQuery<AdminKeyEligibilityT>(AdminKeyEligibility);

	let errorToReportToChildren: typeof error;
	if (error) {
		if (isUnauthorizedError(error)) {
			// If `edition` is not permitted to the current user (e.g. anonymous
			// access is not permitted), then the current user is definitely not
			// eligible for admin key. So here an unauthorized error is an expected
			// error.
			markErrorAsHandled(error);
		} else {
			errorToReportToChildren = error;
		}
	}

	return children({
		canBeSuperAdmin: Boolean(idx(data, (_) => _.user.confluence.roles.canBeSuperAdmin)),
		edition: idx(data, (_) => _.tenant.editions.edition),
		error: errorToReportToChildren,
		loading,
	});
}

AdminKeyEligibilityQuery.propTypes = {
	children: PropTypes.func.isRequired,
};
